import { html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import * as moment from 'moment';
import { ExportToCsv } from 'export-to-csv';
import nls from '../../locales/index.nls';
import style from './ki-station-map.css';

export default
@i18n(nls)
class KiStationDownloadButton extends LitElement {
  // language=CSS
  static styles = style;

  static get properties() {
    return {
      selectedStations: { type: Array },
    };
  }

  render() {
    // language=html
    return html`
      <ki-icon-btn class="download-btn" icon="ki ki-arrow-alt-to-bottom" id="download-btn" @click="${this.downloadStations}"></ki-icon-btn>
      <paper-tooltip for="download-btn" position="left"><span class="tooltip-content">${this.i18n.t('Download_station_list')}</span></paper-tooltip>
    `;
  }

  downloadStations() {
    this.dispatchEvent(
      new CustomEvent("downloadstationsmd", {
        bubbles: true
      }),
    )
    
  }
}

customElements.define('ki-station-download-button', KiStationDownloadButton);
